import { render, staticRenderFns } from "./AudioItem.vue?vue&type=template&id=679d6551&scoped=true&"
import script from "./AudioItem.vue?vue&type=script&lang=ts&"
export * from "./AudioItem.vue?vue&type=script&lang=ts&"
import style0 from "./AudioItem.vue?vue&type=style&index=0&id=679d6551&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679d6551",
  null
  
)

export default component.exports